export { default as Contact } from './contact';
export { default as Newsletter } from './newsletter';
